// Component: src/theme/snippets/input.liquid

const baseHeight = 28;
const largeHeight = 40;

document.addEventListener("DOMContentLoaded", () => {
  const snippetInputs = document.querySelectorAll(".snippet-input");

  snippetInputs.forEach((snippetInput) => {
    const originalHeight = snippetInput.classList.contains("snippet-input--large") ? largeHeight : baseHeight;
    const $textarea = snippetInput.querySelector("textarea");

    if ($textarea) {
      $textarea.parentElement!.style.height = "auto";
      $textarea.addEventListener(
        "input",
        () => {
          // Auto resize
          $textarea.style.height = `${originalHeight}px`;
          const height = $textarea.scrollHeight;
          $textarea.style.height = `${height}px`;

          // Character counter
          const count = $textarea.value.length || 0;
          const $characterCounter = snippetInput.querySelector(".character-counter");
          if ($characterCounter) ($characterCounter as HTMLElement).innerText = count.toString();
        },
        { passive: true },
      );
    }
  });

  // Dropdown
  initDropdown();
});

function initDropdown() {
  const dropdowns = document.getElementsByClassName("dropdown-wrapper");

  for (let i = 0; i < dropdowns.length; i++) {
    const selectElement = dropdowns[i].getElementsByTagName("select")[0];
    const selectedDiv = document.createElement("DIV");
    selectedDiv.setAttribute("class", "select-selected");

    // Find the selected option or default to the first one
    const selectedOption = selectElement.options[selectElement.selectedIndex] || selectElement.options[0];
    selectedDiv.innerHTML = selectedOption.innerHTML;

    // Check if the select element is disabled
    if (selectElement.disabled) {
      dropdowns[i].classList.add("disabled");
    }

    const optionList = document.createElement("DIV");
    optionList.setAttribute("class", "select-items select-hide");

    for (let j = 0; j < selectElement.length; j++) {
      const optionDiv = document.createElement("DIV");
      optionDiv.classList.add("radio-item");

      // Add data-type attribute to the radio-item
      const dataType = selectElement.options[j].getAttribute("data-type");
      if (dataType) {
        optionDiv.setAttribute("data-type", dataType);
      }

      const input = document.createElement("input");
      input.setAttribute("class", "radio-input");
      input.setAttribute("type", "radio");
      input.setAttribute("name", `dropdown-${i}`);
      input.setAttribute("value", selectElement.options[j].value);
      if (j === selectElement.selectedIndex) {
        input.setAttribute("checked", "checked");
      }

      const label = document.createElement("label");
      label.setAttribute("class", "radio-label");
      label.innerHTML = `<div class="radio-label-main">${selectElement.options[j].innerHTML}</div>`;

      optionDiv.appendChild(input);
      optionDiv.appendChild(label);

      // Highlight the selected option
      if (j === selectElement.selectedIndex) {
        optionDiv.classList.add("same-as-selected");
      }

      optionDiv.addEventListener("click", function (e) {
        updateSelect(this, selectElement);
      });

      optionList.appendChild(optionDiv);
    }

    // Insert the new elements after the select element
    selectElement.insertAdjacentElement('afterend', selectedDiv);
    selectedDiv.insertAdjacentElement('afterend', optionList);

    selectedDiv.addEventListener("click", function (e: Event) {
      const dropdownWrapper = this.closest('.dropdown-wrapper')!;

      // Only allow clicking if the dropdown is not disabled
      if (!dropdownWrapper.classList.contains('disabled')) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextElementSibling!.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");

        // Toggle chevron icon
        const iconWrapper = dropdownWrapper.querySelector('.input-icon--dropdown')!;
        if (this.classList.contains("select-arrow-active")) {
          iconWrapper.innerHTML = window.iconChevronUpMd;
        } else {
          iconWrapper.innerHTML = window.iconChevronDownMd;
        }
      }
    });
  }

  document.addEventListener("click", () => closeAllSelect());
}

function updateSelect(clickedOption: HTMLElement, selectElement: HTMLSelectElement) {
  // Only update if the dropdown is not disabled
  if (!clickedOption.closest('.dropdown-wrapper')!.classList.contains('disabled')) {
    const selectedDiv = clickedOption.closest('.dropdown-wrapper')!.querySelector('.select-selected') as HTMLElement;
    const optionList = clickedOption.closest('.select-items') as HTMLElement;
    const radioInput = clickedOption.querySelector('input[type="radio"]') as HTMLInputElement;

    if (radioInput) {
      radioInput.checked = true;
      for (let i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].value === radioInput.value) {
          selectElement.selectedIndex = i;
          selectedDiv.innerHTML = clickedOption.querySelector('.radio-label-main')!.innerHTML;

          optionList.querySelectorAll('.radio-item').forEach(item => {
            item.classList.remove('same-as-selected');
          });

          clickedOption.classList.add('same-as-selected');
          break;
        }
      }
    }

    // Trigger a change event on the select element
    const event = new Event('change', { bubbles: true });
    selectElement.dispatchEvent(event);

    // Close the dropdown
    closeAllSelect();
  }
}

function closeAllSelect(element?: HTMLElement) {
  const selectItems = document.getElementsByClassName("select-items");
  const selectSelected = document.getElementsByClassName("select-selected");
  const arrNo: number[] = [];

  for (let i = 0; i < selectSelected.length; i++) {
    if (element === selectSelected[i]) {
      arrNo.push(i);
    } else {
      selectSelected[i].classList.remove("select-arrow-active");
      // Reset chevron icon to down when closing
      const iconWrapper = selectSelected[i].closest('.dropdown-wrapper')!.querySelector('.input-icon--dropdown')!;
      iconWrapper.innerHTML = window.iconChevronDownMd;
    }
  }

  for (let i = 0; i < selectItems.length; i++) {
    if (arrNo.indexOf(i) === -1) {
      selectItems[i].classList.add("select-hide");
    }
  }
}

window.inputError = ($inputWrapper: HTMLDivElement, message?: string, isHtml = false) => {
  const $helperText: HTMLDivElement | null = $inputWrapper.querySelector(".helper-text");
  if (!$helperText) return;
  $inputWrapper.classList.add("snippet-input--error");
  if (message && isHtml) $helperText.innerHTML = message;
  if (message && !isHtml) $helperText.innerText = message;
  $helperText.classList.remove("hidden");
};

window.inputErrorClear = ($inputWrapper: HTMLDivElement) => {
  const $helperText: HTMLDivElement | null = $inputWrapper.querySelector(".helper-text");
  if (!$helperText) return;
  $inputWrapper.classList.remove("snippet-input--error");
  $helperText.classList.add("hidden");
};

window.inputErrorClearAll = ($form: HTMLFormElement) => {
  $form.querySelectorAll(".snippet-input--error").forEach(($inputWrapper: any) => {
    window.inputErrorClear($inputWrapper);
  });
};

// Add a new function to enable/disable the dropdown
function setDropdownDisabled(dropdownWrapper: HTMLElement, disabled: boolean) {
  const selectElement = dropdownWrapper.querySelector('select') as HTMLSelectElement;
  if (selectElement) {
    selectElement.disabled = disabled;
    if (disabled) {
      dropdownWrapper.classList.add('disabled');
    } else {
      dropdownWrapper.classList.remove('disabled');
    }
  }
}

// Expose the function to the global scope if needed
(window as any).setDropdownDisabled = setDropdownDisabled;
